import { render, staticRenderFns } from "./ot-combo-box-wrapper.vue?vue&type=template&id=522cbf4c&scoped=true&"
import script from "./ot-combo-box-wrapper.vue?vue&type=script&lang=ts&"
export * from "./ot-combo-box-wrapper.vue?vue&type=script&lang=ts&"
import style0 from "./ot-combo-box-wrapper.vue?vue&type=style&index=0&id=522cbf4c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "522cbf4c",
  null
  
)

export default component.exports